// components/LoadingWidget.jsx
import React from 'react';

const LoadingWidget = ({ mensaje = "Cargando datos..." }) => {
  return (
    <div className="flex h-screen w-full items-center justify-center bg-gray-100">
      <div className="text-center">
        {/* Spinner animado */}
        <div className="inline-block h-16 w-16 animate-spin rounded-full border-4 border-solid border-blue-500 border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"></div>
        
        {/* Texto del mensaje */}
        <p className="mt-4 text-lg font-medium text-gray-700 animate-pulse">
          {mensaje}
        </p>
      </div>
    </div>
  );
};

export default LoadingWidget;